/**
 * DetailConfig — options for the procedural detail surface (micro-normal +
 * roughness breakup), with the footprint-filtering knobs added 2026-09-15.
 */
export interface DetailSurfaceOptions {
  /** World-space tiling (noise periods per metre). Default 12. */
  tiling?: number;
  /** Tangent-space normal perturbation strength. Default 0.25. */
  normalStrength?: number;
  /** Roughness breakup amplitude around the authored roughness. Default 0.12. */
  roughnessBreakup?: number;
  /**
   * Footprint filtering: fade the detail as its period drops below the pixel
   * footprint, and hand the unresolved slope energy to roughness instead of
   * flattening the surface into false gloss. Default false.
   */
  filtered?: boolean;
  /** Noise periods per pixel where the fade starts / completes (defaults 0.35 / 1.2). */
  filterStart?: number;
  filterEnd?: number;
  /** Roughness added per unit of faded normal strength² (default 0.5). */
  roughnessTransfer?: number;
}

export interface DetailSurfaceConfig {
  tiling: number;
  normalStrength: number;
  roughnessBreakup: number;
  filtered: boolean;
  filterStart: number;
  filterEnd: number;
  roughnessTransfer: number;
}

export function createDetailConfig(opts: DetailSurfaceOptions = {}): DetailSurfaceConfig {
  return {
    tiling: opts.tiling ?? 12,
    normalStrength: opts.normalStrength ?? 0.25,
    roughnessBreakup: opts.roughnessBreakup ?? 0.12,
    filtered: opts.filtered ?? false,
    filterStart: opts.filterStart ?? 0.35,
    filterEnd: opts.filterEnd ?? 1.2,
    roughnessTransfer: opts.roughnessTransfer ?? 0.5,
  };
}
